<template>
    <v-expansion-panels
        class="border-t border-b"
        variant="accordion"
        multiple
        :model-value="tab"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <v-expansion-panel
            v-for="(panel, index) in tabs"
            :key="index"
            :value="index"
            elevation="0"
            :eager="loaded[index]"
            rounded="0"
            v-slot:default="nevim"
        >
            <v-expansion-panel-title
                class="text-h6 font-weight-black pa-5"
                :class="{'text-orange': index === tab}"
            >
                {{ panel.name }}
            </v-expansion-panel-title>
            <v-expansion-panel-text :class="panel.class">
                <div>
                    <template v-if="'content' in panel">
                        <div v-html="panel.content"/>
                    </template>
                    <template v-else-if="'component' in panel">
                        <component :is="panel.component" v-bind="panel.props"></component>
                    </template>
                    <template v-else>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, culpa, id. Ab
                        animi,
                        blanditiis doloremque eius esse eveniet excepturi expedita explicabo
                        incidunt
                        laborum
                        magnam
                        nostrum odit porro quisquam vitae voluptas!
                    </template>
                </div>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps({
    tab: [Number, String],
    tabs: Array
})

const isLoaded = ref({});

const loaded = computed(() => {
    const _loaded = isLoaded.value[props.tab] || false;
    if(!_loaded){
        isLoaded.value[props.tab] = true;
    }
    return isLoaded.value;
})

const emit = defineEmits(['update:modelValue'])
</script>

<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
:deep(.v-expansion-panel-text__wrapper){
    padding-inline: $spacer * 5 !important;
}
</style>
